import { useLocalSearchParams } from 'expo-router';

import IncomeSplitRuleEditor from '../../../../banking/components/income-split/IncomeSplitRuleEditor';
import IncomeSplitRuleEditorNew from '../../../../banking/components/income-split/IncomeSplitRuleEditorNew';
import useShouldSeeTiedRules from '../../../../banking/hooks/income-split/useShouldSeeRuleSets';

export default function IncomeSplitRuleEditorScreen() {
    const { tiedRules } = useLocalSearchParams<{
        tiedRules: string;
    }>();

    const enableTiedRules = useShouldSeeTiedRules();

    if (tiedRules === 'true' && enableTiedRules) {
        return <IncomeSplitRuleEditorNew />;
    }
    return <IncomeSplitRuleEditor />;
}
